// Unified Dark Design System with Glassmorphic Elements
export const theme = {
  // Dark gradient background
  background: {
    main: 'linear-gradient(135deg, #0c0a1e 0%, #1a1144 25%, #2a1f5f 50%, #1a1144 75%, #0c0a1e 100%)',
    overlay: `
      radial-gradient(circle at 20% 80%, rgba(79, 70, 229, 0.15) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(99, 102, 241, 0.12) 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, rgba(139, 92, 246, 0.08) 0%, transparent 50%)
    `
  },

  // Consistent colors for dark theme
  colors: {
    primary: '#6366f1', // Indigo-500
    secondary: '#8b5cf6', // Violet-500
    accent: '#a855f7', // Purple-500
    text: {
      primary: '#f8fafc', // Slate-50 - Light readable text
      secondary: '#e2e8f0', // Slate-200 - Slightly dimmed
      muted: '#cbd5e1', // Slate-300 - Muted but readable
      accent: '#a5f3fc', // Cyan-200 - For special highlights
      link: '#f97316' // Orange-500 - For URLs and links
    },
    glass: {
      background: 'rgba(255, 255, 255, 0.08)', // More subtle for dark theme
      backgroundStrong: 'rgba(255, 255, 255, 0.12)', // Stronger glass effect
      border: 'rgba(255, 255, 255, 0.15)',
      borderStrong: 'rgba(255, 255, 255, 0.25)',
      shadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
    },
    button: {
      primary: {
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        border: 'rgba(99, 102, 241, 0.5)',
        text: '#ffffff'
      },
      secondary: {
        background: 'rgba(255, 255, 255, 0.1)',
        border: 'rgba(255, 255, 255, 0.2)',
        text: '#f8fafc'
      }
    }
  },

  // Typography with light text focus
  typography: {
    fontFamily: "'Inter', 'Poppins', sans-serif",
    sizes: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      '2xl': '24px',
      '3xl': '32px',
      '4xl': '40px'
    },
    weights: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  },

  // Spacing
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px'
  },

  // Border radius
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    full: '50%'
  },

  // Enhanced shadows for dark theme
  shadows: {
    sm: '0 2px 8px rgba(0, 0, 0, 0.25)',
    md: '0 4px 16px rgba(0, 0, 0, 0.3)',
    lg: '0 8px 32px rgba(0, 0, 0, 0.4)',
    glass: '0 8px 32px rgba(0, 0, 0, 0.3)',
    glassStrong: '0 12px 40px rgba(0, 0, 0, 0.5)'
  },

  // Glassmorphic container styles
  glassContainer: {
    subtle: `
      background: rgba(255, 255, 255, 0.06);
      backdrop-filter: blur(16px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    `,
    normal: `
      background: rgba(255, 255, 255, 0.08);
      backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.15);
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    `,
    strong: `
      background: rgba(255, 255, 255, 0.12);
      backdrop-filter: blur(24px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 20px;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
    `
  },

  // Transitions
  transitions: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease'
  }
};

export default theme;
